import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { GetCategoriesResponse } from '@twiliointernal/e2-commons-shared-definitions';

import { constants } from './definitions';
import { HelpCenterApiV2 } from '@twiliointernal/e2-commons-shared-api';

const helpCenterApi = new HelpCenterApiV2();

export const fetchCategories = async (): Promise<GetCategoriesResponse> => {
  // Direct traffic to OTK if beta feature flag or split experiment is on
  const { data, errorCode, success, message } =
    await helpCenterApi.getCategories();

  // Throwing error so that useQuery isError fails as expected.
  if (!success) {
    throw Error(`${errorCode}: ${message}`);
  }

  const categories = data?.categories ?? [];
  // Filtering out categories without articles
  const products = categories.filter((category) => {
    return category.articles && category.articles.length;
  });

  return { categories: products };
};

// @todo - refactor to make it more general with optional query keys (requires work on support-api as well)
const useFetchArticlesByProducts =
  (): UseQueryResult<GetCategoriesResponse> => {
    const queryKey = [constants.fetchArticlesByCategoriesFnKey];

    return useQuery({
      queryKey,
      queryFn: () => fetchCategories(),
      staleTime: 600 * 1000, // 10 minutes
      retry: false,
    });
  };

export default useFetchArticlesByProducts;
